import { jsx as e } from "react/jsx-runtime";
import { Spinner as n } from "flowbite-react";
import { spinnerTheme as m } from "./theme.js";
const t = (r) => /* @__PURE__ */ e(n, { theme: m, ...r });
export {
  t as Spinner
};
